import React from "react";
import { MyAdminPanelWrapper } from "features/AdminPanel/modules/MyAdminPanelWrapper/MyAdminPanelWrapper";
import { useDesktopMediaQuery } from "features/Common/hooks/useDesktopMediaQuery";
import {
  MANAGE_OFFERINGS_FEATURE_KEY,
  MANAGE_OFFERINGS_HEADER_TITLE,
} from "features/ManageOfferings/constants/ManageOfferings.constants";
import { getManageOfferingRedirectUrl } from "features/ManageOfferings/utils/ManageOffering.utils";
import { useParams } from "react-router-dom";
import { OfferingVariations } from "features/OfferingVariations";
import { OfferingVariationsHeaderActions } from "features/OfferingVariations/pages/OfferingVariationsList/OfferingVariationsHeaderActions";

export const OfferingVariationsWrapper = (props) => {
  const isDesktop = useDesktopMediaQuery();
  const { offeringUuid } = useParams();
  const backUrl = getManageOfferingRedirectUrl({ listingId: offeringUuid });

  return (
    <MyAdminPanelWrapper
      featureKey={`${MANAGE_OFFERINGS_FEATURE_KEY}/${offeringUuid}`}
      classes={{
        childrenComponentStyle: "bg-transparent !tw-p-0",
        ...(!isDesktop && { container: "px-3 top-0" }),
      }}
      headerTitle={
        !isDesktop ? "Manage Variations" : MANAGE_OFFERINGS_HEADER_TITLE
      }
      hideHeader={false}
      {...(!isDesktop
        ? {
            backUrl,
            headerRight: <OfferingVariationsHeaderActions />,
          }
        : {})}
    >
      <OfferingVariations {...props} />
    </MyAdminPanelWrapper>
  );
};
